import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";

import { dutchCrmMessages } from "./dutchCrmMessages";
import { raDutchMessages } from "./raDutchMessages";

export const LOCALE = "nl";

export const dutchCatalog = mergeTranslations(
  raDutchMessages,
  dutchCrmMessages,
);

const locales = [{ locale: LOCALE, name: "Nederlands" }];

/**
 * Single-locale (nl) polyglot provider. Every catalog key exists in Dutch;
 * `allowMissing` only guards against typos in component keys.
 */
export const i18nProvider = polyglotI18nProvider(
  () => dutchCatalog,
  LOCALE,
  locales,
  { allowMissing: true },
);

export const testI18nProvider = i18nProvider;
